<template>
  <div class="viewport-wrapper">
    
    <Breadcrumbs ref="breadcrumbs"/>
    <div class="container-fluid content-area">
      <div class="helper row flex-column-reverse flex-md-row">
        
        <div class="col-12 title" ref="divName">
               <h2 v-if="currentDocument">{{currentDocument.name}}</h2>
        </div>
        
        </div>
        <div class="helper row">        
          <div class="col-12">
            <p v-if="currentDocument" v-html="currentDocument.description"></p>
          </div>       
      </div>
      
      <div class="error-alert" v-if="!dataLoaded || getServiceStatus">
        
          Looks like we are experiencing some technical issues or your request timed out. 
          Please try accessing this service after sometime. 
        
        <br>
       
          For any urgent matter, please contact 3-1-1 or 905-615-4311 outside city limits. 
      </div>
      <div v-if="showWarning" class="alert alert-danger">
          No by-law was found with the requested query. <a class="float-right" href="javascript:void(0);" @click="closeWarning">dismiss</a>
      </div>
      <div v-if="dataLoaded">
        <ByLawPart
          v-for="part in documents.parts"
          :key="part.id"
          :part="part"         
          :subDocuments = "part.children"
          :ref= "'part' + part.id"
          @notify = "showPrintSelectionAlert"
        />
      </div>
    </div>
    <div class="fixed-menu-bottom">
      <a href="javascript:void(0)" @click="collapseAll" title="Collapse All" class="d-block"> 
        <font-awesome-icon :icon="['fas', 'compress']" size="lg" /> </a>  
      <a href="javascript:void(0)" @click="print" title="Print page" class="d-block print-btn" ref="printCommand"> 
         <font-awesome-icon :icon="['fas', 'print']" size="lg" /><span class="notification__badge">*</span> </a> 
      <a href="javascript:void(0)" @click="scrollToTop" title="Back to top" class="d-block"> 
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-up']" size="lg" /> </a> 
    </div>
    <Footer />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Layout/Breadcrumbs";
import ByLawPart from "@/components/ByLawPart";
import PrintIcon from "@/components/Svg/PrintIcon";
import { mapGetters } from "vuex";
import Footer from "@/components/Layout/Footer";
import storageService from "@/services/storage";

export default {
  name: "Container",
  props: {
      documents: Object,
      currentDocument: Object
  },
  data() {
    return {
      componentKey: 1,
      showWarning: false,
      surveyUrl: null
    };
  },
  components: {
    Breadcrumbs,
    ByLawPart,
    PrintIcon,
    Footer
  },
  computed: {
    ...mapGetters("viewer", ["getServiceStatus","dataLoaded", "getShareRequestStatus"])
  },
  mounted: function()
  {
    /*this.surveyUrl = process.env.VUE_APP_SURVEY_URL;
    if(storageService.getSurveyChoice() == null){
      this.$nextTick(this.promptSurvey);
    }*/    
  },
  methods: {
    collapseAll: function(){
      this.$router.push({ path: `/?reset` });
      this.$refs.printCommand.classList.remove("active");
    },
    closeWarning: function(){
      this.showWarning = false;
      this.$router.push({ path: `/` })
    },
    scrollToTop() {       
      this.$refs.breadcrumbs.$el.scrollIntoView();
    },
    promptSurvey(){
      var self = this;
      //this.$alert("This survey will take a few minutes to complete. Your feedback will help us improve the interactive zoning by-law online experience. You can choose to take the survey now or click on the Survey link on the left pane later.");
      this.$fire({
        title: 'Survey',
        icon: 'info',
        html:"<b> Help us improve the Interactive Zoning By-Law experience </b> <br><br>This survey will take a few minutes to complete. Your feedback will help us improve the interactive zoning by-law online experience. You can choose to take the survey now or click on the Survey link on the left pane later.",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        confirmButtonText:
          'Yes, take the survey now',
        confirmButtonAriaLabel: 'yes',
        cancelButtonText:
          'No, thank you',
        cancelButtonAriaLabel: 'No'
      }).then((result) => {
        if (result.value == true) {
          self.showSurvey();
          storageService.setSurveyChoice(result.value);
        } else if (result.dismiss == 'cancel') {
          storageService.setSurveyChoice(result.dismiss);
        }
      });
    },
    showSurvey(){
      window.open(this.surveyUrl, "_blank", "width=900&height=500&location=no");
    },
    showPrintSelectionAlert(){
      let self = this;
      let emptyCount = 0;
      this.documents.parts.forEach(part => {
        let printQ = self.$refs['part'+part.id][0].printQueue; 
        if(printQ.length > 0){
          if(!self.$refs.printCommand.classList.contains("active"))
          {
            self.$refs.printCommand.classList.add("active");
          }
          return true;
        } else {
          emptyCount++;
        }
      }); 
      if(this.documents.parts.length == emptyCount){
        self.$refs.printCommand.classList.remove("active");
      }
    },
    print() {     
      let itemsToPrint = [], self = this;
       this.documents.parts.forEach(part => {
        let printQ = self.$refs['part'+part.id][0].printQueue; 
        itemsToPrint = [...itemsToPrint, ...printQ]
      }); 
     
      if(itemsToPrint.length > 0)
      {
        let routeData = this.$router.resolve({       
          path: "/search-print/"+itemsToPrint.join()
        }); 
        window.open(routeData.href, "_blank", "width=1000&location=no&scrollBar=yes");
      } else {
        window.print();
      }
      
    }
  },
  watch: {    
    getShareRequestStatus: function (newvalue) {
      if(!newvalue){
         this.showWarning = true;   
      }
    }
  }
};
</script>
